module.exports = __webpack_public_path__ + "static/media/KabirSathe.156dc3b3.jpeg";